import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Meta } from '../common/seo.service';
import { FillerService } from '../common/Service_tnFiller';
import * as myLanguages from '../common/vars_translate';

import { FormGroup, FormControl, Validators } from '@angular/forms';


@Component({
  selector: 'app-contact',
  templateUrl: '../themes/default/html/contact.component.html',
  styleUrls: ['../themes/default/css/contact.component.scss']
})
export class ContactComponent implements OnInit {

  Contact = {
    Form: { 
      Title: 'Hai bisogno di informazioni più dettagliate ? Contattaci.',
      Email: 'Indirizzo email',
      FullName: 'Digita il tuo nome e cognome',
      Address: 'Indirizzo',
      CityCode: 'CAP',
      City: 'Città',
      Region: 'Provincia',
      Number: 'il tuo recapito telefonico',
      Fax:'Fax',
      Obj:'Oggetto',
      Desc:'Scrivi qui il tuo messaggio, ti invieremo informazioni dettagliate',
      UiCulture:'it'
    },
    Button: 'Invia Richiesta'
  }

   contactFields = { 
      Title: '',
      Email: '',
      FullName: '',
      Address: '',
      CityCode: '',
      City: '',
      Region: '',
      Number: '',
      Fax:'',
      Obj:'',
      Desc:'',
      Agreements: false,
      UiCulture: 'it'
    }

  contactForm: any;

  SingleAd = [];
  // {
  //   Validators: [] 
  // };

  form: FormGroup;
  payLoad = '';

  infoPrivacy: any = "";

  constructor(private myMeta: Meta, private filler: FillerService) {
    myMeta.setTitle('Contatti');
    this.SingleAd = Object.assign([],myLanguages.translations_IT.SingleAd);

    new Promise((resolve, reject) => {
      this.filler.Get_Privacy().subscribe(
          data => {
            this.infoPrivacy = Object.assign([], data)
            resolve(true);
          }, err => { console.log(err) }
        );
    }).then(
      e => console.log('')
    );

    // this.fullName = new Control('', UsernameValidator.startsWithNumber);

   }

  ngOnInit() {
    // this.form = new FormGroup({
    //   FullName: new FormControl(null, Validators.required),
    //   Address: new FormControl(null, Validators.required),
    //   Email: new FormControl(null, [
    //     Validators.required,
    //     Validators.pattern("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?")
    //   ]),
    //   password: new FormControl(null, Validators.required)
    // });
  }

  sendEmail() {
    console.log("Invio email in corso");
    var emailReq =  Object.assign([], this.contactFields)
    this.filler.Send_EmailContacts(this.contactFields).subscribe(
      data => { 
        console.log(data);
      }
    )
  }

}



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/contact/contact.component.ts